import {
  SAVE_ITEM_SKUS,
} from '../../actions/actionTypes'

import reducerCreator from './higherOrderEntityReducers/basicReducerCreator'

export default reducerCreator([
  SAVE_ITEM_SKUS,
])
